var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"t-rr-s-user-setting-wrapper"},[_c('div',{staticClass:"t-rr-s-user-setting-header"},[_c('div',{staticClass:"t-rr-s-user-setting-header-title"},[_c('h5',[_vm._v(_vm._s(_vm.$t('Settings.FAQ')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }